import { Controller } from "@hotwired/stimulus";
import debounce from "lodash/debounce";

export default class extends Controller {
  initialize() {
    this.submit = debounce(this.submit, 250);
  }

  connect() {
    console.log("form connected");
  }

  disconnect() {}

  submit() {
    this.element.requestSubmit();
  }

  reset() {
    this.element.querySelectorAll("input[type=text], input[type=search]").forEach((input) => {
      input.value = "";
    });
  }
}
